import { useEffect, useState } from 'react'
import { Grid, List } from 'semantic-ui-react'

import {
  GridRowColumn,
  Text,
  Alert,
  Checkbox,
} from '@/componentsV1/BaseComponents'
import { StepHeaders } from '@/features/bookkeeping/step-header'
import './styles.scss'
import { ReviewStepCard } from '@/features/bookkeeping/review-step'
import { IStep } from '../step-map'
import { useReselector } from '@/utils/sharedHooks'
import { selectCurrentAnnualTaxYear } from '@/features/admin/annual-tax-details/annualTaxDetails.selector'

export const Review = ({
  userSteps,
  setReviewIndex,
  setIsStepComplete,
}: {
  userSteps: IStep[]
  setReviewIndex: (route: string) => void
  setIsStepComplete: (value: boolean) => void
}) => {
  const currentTaxYear = useReselector(selectCurrentAnnualTaxYear)
  const [isChecked, setIsChecked] = useState(false)
  const [reviewSteps, setReviewSteps] = useState<IStep[]>(userSteps)
  useEffect(() => {
    const steps = userSteps
    const filteredSteps: IStep[] = []
    for (const step of steps) {
      if (step?.route) {
        if (step?.finalReviewGroup) {
          filteredSteps.push(step)
        }
      }
    }
    setReviewSteps(filteredSteps)
  }, [userSteps])

  const onChangeSkipAccountReconnect = () => {
    const newCheckedState = !isChecked
    setIsChecked(newCheckedState)
    setIsStepComplete(newCheckedState)
  }

  return (
    <Grid className="income-grid">
      <GridRowColumn centerContent className="header-container">
        <StepHeaders
          imageSrc="https://heard-images.s3.amazonaws.com/assets/magnifying-glass.svg"
          imageAlt="magnifying glass"
          imageWidth={140}
          imageHeight={140}
          title="Review Answers"
          description=""
          customColor="yellow"
        >
          <Grid>
            <GridRowColumn className="align-left">
              <Text>
                Please review your answers, as{' '}
                <b>
                  you can’t make any changes or add more transactions to your{' '}
                  {currentTaxYear} books
                </b>{' '}
                after you submit.
              </Text>
            </GridRowColumn>
            <GridRowColumn className="align-left">
              {reviewSteps?.map((step, index) => {
                if (step?.name) {
                  if (
                    step.finalReviewGroup !==
                      (reviewSteps[index + 1]
                        ? reviewSteps[index + 1].finalReviewGroup
                        : '') &&
                    index !== reviewSteps.length - 1
                  ) {
                    return (
                      <>
                        <ReviewStepCard
                          key={step.route}
                          step={step}
                          setReviewIndex={setReviewIndex}
                          isPending={false}
                        />
                        <div className="group-text-card">
                          <Text as="eyebrow" color="darkGray">
                            {reviewSteps[index + 1].reviewGroupLabel}
                          </Text>
                        </div>
                      </>
                    )
                  } else {
                    return (
                      <>
                        {index === 0 && (
                          <div className="group-text-card">
                            <Text as="eyebrow" color="darkGray">
                              {step.reviewGroupLabel}
                            </Text>
                          </div>
                        )}
                        <ReviewStepCard
                          key={step.route}
                          step={step}
                          setReviewIndex={setReviewIndex}
                          isPending={false}
                        />
                      </>
                    )
                  }
                }
                return null
              })}
            </GridRowColumn>
            <GridRowColumn>
              <Alert
                title="You acknowledge that:"
                style={{ width: '520px' }}
                customIcon="none"
                contentStyle={{ textAlign: 'left' }}
                type="acknowledge"
              >
                <div className="my-4 ml-2">
                  <List bulleted className="flex-column">
                    <List.Item>
                      <Text>
                        You’ve reviewed all of your answers above. They can’t be
                        modified after submission.
                      </Text>
                    </List.Item>
                    <List.Item>
                      Your {currentTaxYear} books will be locked upon
                      submission. You won’t be able to add or modify
                      transactions for this year.
                    </List.Item>
                  </List>
                </div>
                <Checkbox
                  id={'acknowledge'}
                  label="I acknowledge the above"
                  checked={isChecked}
                  onChange={onChangeSkipAccountReconnect}
                />
              </Alert>
            </GridRowColumn>
          </Grid>
        </StepHeaders>
      </GridRowColumn>
    </Grid>
  )
}

export default Review
